import React, { useState } from "react";
import {
  Container,
  Box,
  Dialog,
  DialogContent,
  Typography,
  Button,
  Slide,
} from "@mui/material";
// No longer need unused icon imports
import defaultLogo from "../assets/logo-img.png";
import MapComponent from "../components/MapComponent";
import StoreCard from "../components/StoreCard";

import { salinasStores } from "../components/MapComponent";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Home = () => {
  const [openInfo, setOpenInfo] = useState(true);

  const handleClose = () => {
    setOpenInfo(false);
  };

  return (
    <Container
      disableGutters
      maxWidth={false}
      sx={{
        maxWidth: { xs: "600px", md: "1200px" }, // Wider container for desktop
        minHeight: "100vh",
        pb: 0, // Removed bottom padding entirely
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        margin: "0 auto",
        backgroundColor: "#fcfcfc",
      }}
    >
      {/* Header with Jomar Banner and Logo */}
      <Box
        sx={{
          width: "100%",
          position: "relative",
          mb: { xs: 6, md: 8 }, // Adjusted margin bottom to make room for the text and larger logo below
        }}
      >
        {/* Banner Background */}
        <Box
          sx={{
            height: { xs: 160, md: 240 }, // Taller on desktop to show more of the image
            width: "100%",
            backgroundImage: `url(${require("../assets/tamales-salinas/bg.jpg")})`,
            backgroundSize: "cover",
            backgroundPosition: { xs: "center", md: "center 40%" }, // Adjust position on desktop for better framing
            borderBottomLeftRadius: "32px",
            borderBottomRightRadius: "32px",
            position: "relative",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          }}
        >
          {/* Dark Overlay */}
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0,0,0,0.35)",
              borderBottomLeftRadius: "32px",
              borderBottomRightRadius: "32px",
            }}
          />
        </Box>

        {/* Circular Logo overlapping the bottom */}
        <Box
          sx={{
            position: "absolute",
            bottom: -50,
            left: { xs: "50%", md: "50%" },
            transform: "translateX(-50%)",
            width: { xs: 100, md: 120 }, // Slightly larger logo on desktop
            height: { xs: 100, md: 120 },
            borderRadius: "50%",
            backgroundColor: "white",
            border: "4px solid white",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
            zIndex: 2,
          }}
        >
          <img
            src={require("../assets/tamales-salinas/logo.png")}
            alt="Tamales Salinas Logo"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />
        </Box>
      </Box>

      {/* Main Title / Description Text */}
      <Box sx={{ width: "100%", px: 2, mb: 4, textAlign: "center" }}>
        <Typography variant="h5" fontWeight="bold" sx={{ mb: 1, color: "#1a1a1a" }}>
          Tamales Salinas
        </Typography>
        <Typography variant="body1" sx={{ color: "#666", fontSize: "0.95rem" }}>
          Selecciona tu sucursal más cercana y crea tu pedido
        </Typography>
      </Box>
      
      {/* Map and Stores Section - Flex Layout */}
      <Box 
        sx={{ 
          width: "100%", 
          flexGrow: 1, 
          display: "flex", 
          flexDirection: { xs: "column", md: "row" }, // Stack on mobile, row on desktop (Blocks left, Map right)
          px: { xs: 2, md: 4 }, 
          mb: 4,
          gap: 4 // Space between blocks and map
        }}
      >
        {/* Left Side: Store Blocks */}
        <Box 
          sx={{ 
            width: { xs: "100%", md: "50%" }, // 50% width on desktop
            display: "grid",
            gridTemplateColumns: "1fr 1fr", // ALWAYS 2 columns
            gap: 2,
            alignContent: "start", // Align blocks to top
            order: { xs: 2, md: 1 }, // On mobile it's second (below map), on desktop it's first (left)
          }}
        >
          {salinasStores.map((store) => (
            <StoreCard key={store.id} store={store} />
          ))}
        </Box>

        {/* Right Side: Map Component */}
        <Box 
          sx={{ 
            width: { xs: "100%", md: "50%" }, // 50% width on desktop
            display: "flex", 
            flexDirection: "column",
            order: { xs: 1, md: 2 }, // On mobile it's first (top), on desktop it's second (right)
          }}
        >
          <Box 
            sx={{ 
              flexGrow: 1, 
              minHeight: "400px", 
              width: "100%", 
              borderRadius: "12px", 
              overflow: "hidden", 
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)" 
            }}
          >
            <MapComponent />
          </Box>
        </Box>
      </Box>

      {/* Intro Modal / Pop-up */}
      <Dialog
        open={openInfo}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        PaperProps={{
          sx: {
            borderRadius: "24px",
            padding: "24px 16px",
            maxWidth: "400px",
            width: "90%",
            textAlign: "center",
            boxShadow: "0 12px 32px rgba(0,0,0,0.15)",
          },
        }}
      >
        <DialogContent sx={{ overflowY: "visible", p: 1 }}>
          <Typography
            variant="h5"
            fontWeight="bold"
            sx={{ mb: 4, color: "#1a1a1a" }}
          >
            ¿Cómo funciona?
          </Typography>

          <Box
            sx={{ display: "flex", flexDirection: "column", gap: 3.5, mb: 4 }}
          >
            {/* Step 1 */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                textAlign: "left",
                gap: 2,
              }}
            >
              <Box
                sx={{
                  minWidth: 44,
                  height: 44,
                  borderRadius: "50%",
                  backgroundColor: "#dc2626", // Tamales Red
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "bold",
                  fontSize: "1.2rem",
                  color: "white",
                }}
              >
                1
              </Box>
              <Typography
                sx={{
                  fontWeight: 600,
                  color: "#333",
                  fontSize: "1.1rem",
                  lineHeight: 1.2,
                }}
              >
                Ubica tu sucursal más cercana en el mapa
              </Typography>
            </Box>

            {/* Step 2 */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                textAlign: "left",
                gap: 2,
              }}
            >
              <Box
                sx={{
                  minWidth: 44,
                  height: 44,
                  borderRadius: "50%",
                  backgroundColor: "#dc2626", // Tamales Red
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "bold",
                  fontSize: "1.2rem",
                  color: "white",
                }}
              >
                2
              </Box>
              <Typography
                sx={{
                  fontWeight: 600,
                  color: "#333",
                  fontSize: "1.1rem",
                  lineHeight: 1.2,
                }}
              >
                Selecciona la sucursal para ver sus detalles
              </Typography>
            </Box>

            {/* Step 3 */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                textAlign: "left",
                gap: 2,
              }}
            >
              <Box
                sx={{
                  minWidth: 44,
                  height: 44,
                  borderRadius: "50%",
                  backgroundColor: "#dc2626", // Tamales Red
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "bold",
                  fontSize: "1.2rem",
                  color: "white",
                }}
              >
                3
              </Box>
              <Typography
                sx={{
                  fontWeight: 600,
                  color: "#333",
                  fontSize: "1.1rem",
                  lineHeight: 1.2,
                }}
              >
                Visítanos y recoge tus tamales
              </Typography>
            </Box>
          </Box>

          <Button
            fullWidth
            variant="contained"
            onClick={handleClose}
            sx={{
              mt: 2,
              backgroundColor: "#dc2626", // Tamales Red
              color: "white",
              borderRadius: "16px",
              padding: "14px",
              textTransform: "none",
              fontWeight: "bold",
              fontSize: "1.1rem",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              "&:hover": {
                backgroundColor: "#b91c1c",
              },
            }}
          >
            ¡Entendido!
          </Button>
        </DialogContent>
      </Dialog>

      {/* Footer Powered by mennu.mx */}
      <Box
        sx={{
          mt: "auto",
          pt: 2,
          pb: 2,
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <a
          href="https://mennu.mx"
          target="_blank"
          rel="noreferrer"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textDecoration: "none",
            backgroundColor: "#FFFFFF",
            borderRadius: "12px", // Slightly smaller border radius to match smaller size
            padding: "8px 20px", // Reduced padding
            margin: "0 auto",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)", // Softer shadow
            maxWidth: "fit-content",
            gap: "2px", // Tightened gap between text and logo
          }}
        >
          <div
            style={{
              color: "#555555", // Slightly lighter gray so it's less dominant
              fontSize: "11px", // Much smaller font
              fontFamily: '"Montserrat", sans-serif',
              fontWeight: "bold", // Changed to bold
              textAlign: "center",
              whiteSpace: "nowrap",
            }}
          >
            Powered by
          </div>
          <img
            src={defaultLogo}
            alt="Mennu.mx logo"
            style={{
              height: "22px", // Much smaller logo (from 36px)
              width: "auto",
              display: "block",
            }}
          />
        </a>
      </Box>
    </Container>
  );
};

export default Home;
